export default __webpack_public_path__ + "static/media/cancellationReason.e59db2f2.svg";